import { Component } from '@angular/core';

import { CoreBuildingBlockControlBaseComponent } from '../../shared/building-block-control-base.component';
import { CoreBuildingBlock } from '../../shared/building-block.decorator';

/**
 * Building block to display readonly information
 */
@CoreBuildingBlock('bulleted-list')
@Component({
  selector: 'cu-bulleted-list',
  templateUrl: './bulleted-list.component.html',
  standalone: false
})
export class BulletedListComponent extends CoreBuildingBlockControlBaseComponent {}
